(function () {
  function activateDeferredThirdParty() {
    document.documentElement.classList.add('third-party-ready');
  }

  ['scroll', 'click', 'keydown', 'touchstart'].forEach(function (eventName) {
    window.addEventListener(eventName, activateDeferredThirdParty, {
      once: true,
      passive: true,
    });
  });

  if ('requestIdleCallback' in window) {
    requestIdleCallback(activateDeferredThirdParty, { timeout: 5000 });
  } else {
    setTimeout(activateDeferredThirdParty, 5000);
  }
})();
